<template>
  <form>
    <!-- 門牌圖片下拉選單 -->
    <div class="dropdown_title">
      <p class="title">門牌圖片</p>
      <a href="#" v-on:click.prevent="showDropDown = !showDropDown">
        <div class="title">{{ getImageOptionLabel }}</div>
        <i
          :class="{
            'fa-caret-up': showDropDown,
            'fa-caret-down': !showDropDown,
          }"
          class="fa"
          aria-hidden="true"
        ></i>
      </a>
      <transition name="slide-fade">
        <div class="choice" v-if="showDropDown">
          <ul>
            <li v-for="(option, index) in imageOptions" :key="index">
              <span v-on:click="updateImageOption(option.value)">{{
                option.label
              }}</span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- 圖片描述，當門牌圖片選擇自訂才出現-->
    <div
      v-if="
        engraving_content.content.commemorativeDoorplateImageOption === 'custom'
      "
    >
      <div class="form-title-container">
        <p>圖片描述</p>
        <div class="image_custom" :class="{ 'is-over': isImageCustomOver }">
          <span>{{ imageCustomLength }}</span>
          <span>/</span>
          <span>{{ imageCustomLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：XXX品牌Logo"
        v-model="engraving_content.content.commemorativeDoorplateImageCustom"
      />
      <p>製圖人員會依照您提供的圖片敘述作為後續與你討論完稿的依據。</p>
    </div>
    <!-- 縣市區域 -->
    <div>
      <div class="form-title-container">
        <p>縣市區域</p>
        <div class="district" :class="{ 'is-over': isDistrictOver }">
          <span>{{ districtLength }}</span>
          <span>/</span>
          <span>{{ districtLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：中西區"
        v-model="engraving_content.content.commemorativeDoorplateDistrict"
      />
    </div>
    <!-- 路名 -->
    <div>
      <div class="form-title-container">
        <p>路名</p>
        <div class="road_name" :class="{ 'is-over': isRoadNameOver }">
          <span>{{ roadNameLength }}</span>
          <span>/</span>
          <span>{{ roadNameLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：西門路二段"
        v-model="engraving_content.content.commemorativeDoorplateRoadName"
      />
    </div>
    <!-- 門牌號 -->
    <div>
      <div class="form-title-container">
        <p>門牌號</p>
        <div class="house_number" :class="{ 'is-over': isHouseNumberOver }">
          <span>{{ houseNumberLength }}</span>
          <span>/</span>
          <span>{{ houseNumberLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：263"
        v-model="engraving_content.content.commemorativeDoorplateHouseNumber"
      />
    </div>
    <!-- 反面文字 -->
    <div>
      <div class="form-title-container">
        <p>反面文字</p>
        <div class="reverse_text" :class="{ 'is-over': isReverseTextOver }">
          <span>{{ reverseTextLength }}</span>
          <span>/</span>
          <span>{{ reverseTextLimit }}</span>
        </div>
      </div>
      <input
        type="text"
        placeholder="例：福祿壽喜財"
        v-model="engraving_content.content.commemorativeDoorplateReverseText"
      />
    </div>
    <p class="note">畫面呈現為示意圖，正式製作稿件將由專業人員編排製版完成。</p>
  </form>
</template>
<script>
import {
  engravingDefaultContent,
  commemorativeDoorplateImageOptions,
} from "@/constData/engravingData";

export default {
  name: "MetalTextCommemorativeDoorplate",
  data() {
    return {
      showDropDown: false,
      imageOptions: commemorativeDoorplateImageOptions,
      engraving_content: {
        type: "commemorative_doorplate",
        content: {
          commemorativeDoorplateImageOption: "",
          commemorativeDoorplateImageCustom: "",
          commemorativeDoorplateDistrict: "",
          commemorativeDoorplateRoadName: "",
          commemorativeDoorplateHouseNumber: "",
          commemorativeDoorplateReverseText: "",
        },
      },
      // 字數限制（從 store 讀取）
      districtLimit: 0,
      roadNameLimit: 0,
      houseNumberLimit: 0,
      imageCustomLimit: 0,
      reverseTextLimit: 0,
    };
  },
  created() {
    // 從 store 讀取現有資料或使用預設值
    const storeContent = this.$store.getters.currentCustom.engraving_content;

    if (storeContent.type === "commemorative_doorplate") {
      this.engraving_content = storeContent;
    } else {
      this.engraving_content.content = {
        ...engravingDefaultContent.commemorative_doorplate,
      };
    }

    // 獲取字數限制配置
    let componentCode = this.$store.getters.getComponentCode;
    let textLimit =
      this.$store.getters.textSettingByComponentCode(componentCode);

    // 計算總字數限制
    this.districtLimit =
      textLimit.commemorativeDoorplateDistrict.lineLimit *
      textLimit.commemorativeDoorplateDistrict.textLimit;
    this.roadNameLimit =
      textLimit.commemorativeDoorplateRoadName.lineLimit *
      textLimit.commemorativeDoorplateRoadName.textLimit;
    this.houseNumberLimit =
      textLimit.commemorativeDoorplateHouseNumber.lineLimit *
      textLimit.commemorativeDoorplateHouseNumber.textLimit;
    this.imageCustomLimit =
      textLimit.commemorativeDoorplateImageCustom.textLimit;
    this.reverseTextLimit =
      textLimit.commemorativeDoorplateReverseText.textLimit;
  },
  computed: {
    // 取得當前選項的 label 文字
    getImageOptionLabel() {
      const option = this.imageOptions.find(
        (opt) =>
          opt.value ===
          this.engraving_content.content.commemorativeDoorplateImageOption
      );
      return option ? option.label : "";
    },
    // 字數計數
    districtLength() {
      return this.engraving_content.content.commemorativeDoorplateDistrict
        .length;
    },
    roadNameLength() {
      return this.engraving_content.content.commemorativeDoorplateRoadName
        .length;
    },
    houseNumberLength() {
      return this.engraving_content.content.commemorativeDoorplateHouseNumber
        .length;
    },
    imageCustomLength() {
      return this.engraving_content.content.commemorativeDoorplateImageCustom
        .length;
    },
    reverseTextLength() {
      return this.engraving_content.content.commemorativeDoorplateReverseText
        .length;
    },
    // 是否超過限制
    isDistrictOver() {
      return this.districtLength > this.districtLimit;
    },
    isRoadNameOver() {
      return this.roadNameLength > this.roadNameLimit;
    },
    isHouseNumberOver() {
      return this.houseNumberLength > this.houseNumberLimit;
    },
    isImageCustomOver() {
      return this.imageCustomLength > this.imageCustomLimit;
    },
    isReverseTextOver() {
      return this.reverseTextLength > this.reverseTextLimit;
    },
    // 是否有任何欄位超過限制
    isAnyFieldOver() {
      // 檢查縣市區域
      if (this.isDistrictOver) return true;

      // 檢查路名
      if (this.isRoadNameOver) return true;

      // 檢查門牌號
      if (this.isHouseNumberOver) return true;

      // 檢查反面文字
      if (this.isReverseTextOver) return true;

      // 只在選擇「自訂」時檢查圖片敘述
      if (
        this.engraving_content.content.commemorativeDoorplateImageOption ===
          "custom" &&
        this.isImageCustomOver
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    "engraving_content.content": {
      handler() {
        this.updateCostom();
      },
      deep: true,
    },
  },
  methods: {
    updateCostom() {
      let payload = {
        key: "engraving_content",
        content: this.engraving_content,
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateImageOption(value) {
      this.engraving_content.content.commemorativeDoorplateImageOption = value;

      // 切換選項時清空相關欄位
      if (value !== "custom") {
        this.engraving_content.content.commemorativeDoorplateImageCustom = "";
      }

      this.updateCostom();
      this.showDropDown = false;
    },
    checkoutTextLimit() {
      return this.isAnyFieldOver ? "over" : "ok";
    },
  },
};
</script>
<style scoped lang="scss">
.image_custom,
.district,
.road_name,
.house_number,
.reverse_text {
  color: #4a4a4a;
  transition: color 0.2s ease;

  &.is-over {
    color: red;
  }
}
</style>
